// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  recaptchaSiteKey: '6LexOq4hAAAAAG5JYzS2EL2j0tufqQOzQ2Q7bAW-',
  firebaseURL: 'https://avantamarketing.com',
  firebase: {
    apiKey: "AIzaSyBmKnymuLFyM69HWHAkr9kRJNx_DamiiXg",
    authDomain: "avantamarketing-d66a5.firebaseapp.com",
    projectId: "avantamarketing-d66a5",
    storageBucket: "avantamarketing-d66a5.appspot.com",
    messagingSenderId: "716244246668",
    appId: "1:716244246668:web:f898c92d20bdfac87f5ba9",
    measurementId: "G-C92WY1NSN9"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
